import { MergeDataCommon } from "_fil_local_addon/camc-cms-base/index";
import { FUND_API_SOURCES } from "_fil_local_addon/camc-cms-base/amc_fund_api.constant";

import CAMCFundOverview from "./camc-fund-overview";

class WebsiteCAMCFundOverview extends CAMCFundOverview {
    errorHandler() {
        showApiMessageing(this.$camcFundOverviewTable);
        this.$camcFundOverviewTable.css("margin-left", "-15px");
    }

    renderFundOverview(fields) {
        fields.forEach((field) => {
            this.$camcFundOverviewTable.find(field.selector).html(MergeDataCommon.formatString(field.data));
        });

        if (this.fundManagerData?.data && this.fundManagerData?.data.length) {
            const fundManagers = this.fundManagerData.data
                .filter((item) => item.titleDisplayState != "HIDE")
                .map((item) => item.name)
                .join("，</span><span>");
            this.$camcFundOverviewTable
                .find("#fund-managers")
                .html(`<span>${MergeDataCommon.formatString(fundManagers)}</span>`);
        } else if (this.fundManagerData == null) {
            showApiMessageing();
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    if (window.fundCode) {
        const camcFundOverview = new WebsiteCAMCFundOverview(window.fundCode, ".camc-fund-overview-table");
        camcFundOverview.render();
    }
});
